const PROCESSING = "processing";
const COMPLETED = "completed";
const FAILED = "failed";
const READING_DOCUMENT = "reading_documents";
const CONSOLIDATING_LEASE = "consolidating";
const VALIDATING = "validating";
const RETRIEVING_DATA = "retrieving_data";
const SPLITTING_DOCUMENT = "split_detected";

export const MAX_RETRIES = 3;
export const REFERRAL_CREDIT = 3;

export const ABSTRACT_REQUEST_STATUSES = {
  PROCESSING,
  COMPLETED,
  FAILED,
};

export const ABSTRACTION_STEPS = {
  SPLITTING_DOCUMENT,
  READING_DOCUMENT,
  VALIDATING,
  RETRIEVING_DATA,
  CONSOLIDATING_LEASE,
};

export const ABSTRACTION_STEP_ORDER = [
  SPLITTING_DOCUMENT,
  READING_DOCUMENT,
  RETRIEVING_DATA,
  CONSOLIDATING_LEASE,
  VALIDATING,
];
